import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, INSTAGRAM_URL } from "../../lib/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-cs-navy-deep py-10 text-[#cfd8dd]">
    <div className="mx-auto flex max-w-6xl flex-col gap-6 px-5 sm:px-8 md:flex-row md:items-center md:justify-between">
      <Logo light testId="footer-logo" />
      <div data-testid="footer-copyright" className="text-sm">
        <div>© 2026 Stop Cheni – Écublens, Vaud</div>
        <div className="mt-1 text-xs text-[#cfd8dd]/80">{COMPANY.street}, {COMPANY.npa} {COMPANY.city} · <a href={`tel:${COMPANY.tel}`} className="nav-link" data-testid="footer-phone-link">{COMPANY.phone}</a></div>
      </div>
      <div className="flex flex-wrap items-center gap-6 text-sm">
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="nav-link inline-flex items-center gap-1.5">
          <Instagram className="h-4 w-4" /> @stopcheni.ch
        </a>
        <Link to="/mentions-legales" data-testid="footer-mentions-link" className="nav-link">Mentions légales</Link>
        <Link to="/confidentialite" data-testid="footer-privacy-link" className="nav-link">Confidentialité</Link>
        <Link to="/app/admin/login" data-testid="footer-admin-link" className="nav-link">Accès administration</Link>
      </div>
    </div>
  </footer>
);
